export default "__VITE_ASSET__DnhkM2xj__"